import React from 'react';
import { Clock, CheckCircle2, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { DESTINATION_SPECIFIC_DATA } from '../../constants/destinationData';
import { COMPANY } from '../../mock';

export default function PerfectDuration({ slug = 'shimla', title = "Pick Your Perfect Duration" }) {
  const data = DESTINATION_SPECIFIC_DATA[slug] || DESTINATION_SPECIFIC_DATA['shimla'];
  const durations = data.durations;
  const destName = slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

  return (
    <section className="py-16 bg-brand-grey/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-poppins text-[32px] lg:text-[42px] text-brand-blue leading-tight mb-4">{title}</h2>
          <p className="text-brand-blue/60 text-[16px] lg:text-[18px]">Honest prices. No hidden charges. EMI options available.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {durations.map((d, i) => {
            const message = `Hi, I want to plan a ${destName} trip. I am interested in the ${d.duration} (${d.bestFor}) package priced at ₹${d.price.toLocaleString('en-IN')}. Please share details.`;
            const waLink = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(message)}`;

            return (
            <div 
              key={i} 
              className={`relative bg-white rounded-[2rem] p-8 border-2 transition-all duration-300 flex flex-col ${
                d.popular 
                ? 'border-brand-orange shadow-premium scale-[1.02] z-10' 
                : 'border-brand-greyDark hover:border-brand-orange/30 shadow-card hover:shadow-lg'
              }`}
            >
              {d.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-orange text-white text-[11px] font-bold uppercase tracking-widest px-4 py-1.5 rounded-full shadow-lg flex items-center gap-1.5 whitespace-nowrap">
                  <Sparkles size={12}/> Most Popular
                </div>
              )}

              <div className="mb-6">
                <div className="text-brand-blue/50 text-[13px] font-bold uppercase tracking-widest mb-1">{d.duration}</div>
                <div className="flex items-baseline gap-1">
                  <span className="text-[28px] font-poppins font-bold text-brand-blue">₹{d.price.toLocaleString('en-IN')}</span>
                  <span className="text-brand-blue/50 text-[13px]">/person</span>
                </div>
              </div>

              <div className="mb-6">
                <div className="text-brand-orange text-[12px] font-bold uppercase tracking-wider mb-2">Best for:</div>
                <div className="text-brand-blue font-semibold text-[15px]">{d.bestFor}</div>
              </div>

              <ul className="space-y-3 mb-8 flex-grow">
                {d.inclusions.map((inc, j) => (
                  <li key={j} className="flex items-start gap-2.5 text-brand-blue/70 text-[13.5px]">
                    <CheckCircle2 size={16} className="text-brand-orange shrink-0 mt-0.5"/>
                    {inc}
                  </li>
                ))}
              </ul>

              <a href={waLink} target="_blank" rel="noreferrer" className="block w-full mt-auto">
                <Button 
                  className={`w-full h-12 rounded-xl font-bold transition-all ${
                  d.popular 
                  ? 'bg-brand-orange hover:bg-brand-orangeDark text-white shadow-md hover:shadow-lg' 
                  : 'bg-brand-blue/5 hover:bg-brand-orange hover:text-white text-brand-blue border border-brand-blue/10'
                }`}>
                  Get Free Quote <ArrowRight size={16} className="ml-2"/>
                </Button>
              </a>
            </div>
          )})}
        </div>
      </div>
    </section>
  );
}
